export default [
  {
    title: "Name",
    type: "text",
    required: true,
    initialValue: "",
    dataIndex: "name",
  },
];
